import { resourceSelectors } from '../../utils/resourceSelectors';

export const [officesAllIds, officesById, allOfficesSelector] =
  resourceSelectors('offices');
